import { isNumeric } from '../../../../js/app/react/validators';

const shouldSkip = (isGoingForward, taxesLocation) =>
  isGoingForward && (isNumeric(taxesLocation) && taxesLocation !== 0);

export default shouldSkip;
